import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminGuard } from './core/services/admin.guard';
import { HomeComponent } from './home/home.component';

const routes: Routes = [
  { path: 'admin', loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule), canActivate: [AdminGuard] },
  { path: 'devis', loadComponent: () => import('./devis/devis.component').then(c => c.DevisComponent) },
  { path: 'contact', loadComponent: () => import('./contact/contact.component').then(c => c.ContactComponent) },
  { path: 'accueil', loadComponent: () => import('./accueil/accueil.component').then(c => c.AccueilComponent) },
  // {path: 'contactez-nous', loadChildren: () => import('./contact-us/contact-us.module').then(m => m.ContactUsModule), component: ContactUsComponent},
  // {path: ':eventSlug', loadComponent: () => import('./event-page/event-page.component').then(m => m.EventPageComponent)},
  { path: ':slug', loadChildren: () => import('./event-page/event-page.module').then(m => m.EventPageModule) },
  { path: '', component: HomeComponent },
  { path: '**', redirectTo: '', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabledBlocking',
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
